import { render, staticRenderFns } from "./InquiryEdit.vue?vue&type=template&id=a009b868"
import script from "./InquiryEdit.vue?vue&type=script&lang=js"
export * from "./InquiryEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports